import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiLink, EuiPageTemplate, EuiButtonIcon, EuiPageHeader, EuiCard, EuiIcon } from '@elastic/eui';
import { Header } from './components/header';
import { Footer } from './components/footer';
import map from '../logos/maps-logo.svg'
import gmail from '../logos/gmail.svg'
import phone from '../logos/phone.svg'
import researchgate from '../logos/researchgate.svg'
import googlescholar from '../logos/googlescholar.svg'
import github from '../logos/github.svg'

class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
        }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Contacts</font></h2></EuiText>
                        <EuiSpacer size='m' />
                </EuiFlexItem>
                </EuiFlexGroup>
                <EuiFlexGroup><EuiFlexItem>
                    <EuiCard
                    icon={<EuiIcon type={map} size="xl" />}
                    layout='horizontal'
                    textAlign="left"
                    title={<EuiText><b>Address</b> </EuiText>}
                    titleSize="xs">
                        <EuiLink color='text' href='https://goo.gl/maps/MANvoZrDSkHcMgLG8' target='_blank'>"Housai Bungalow", Shivaji Nagar, Satara-Pandharpur Road, Koregaon, Satara, Maharashtra - 415501</EuiLink>
                    </EuiCard>
                </EuiFlexItem>
                <EuiFlexItem>
                    <EuiCard
                    icon={<EuiIcon type="branch" size="xl" />}
                    layout='horizontal'
                    textAlign="left"
                    title={<EuiText><b>Social Profiles</b> </EuiText>}
                    titleSize="xs">
                        <EuiFlexGroup>
                        <EuiFlexItem grow={false}><EuiButtonIcon iconType={researchgate} iconSize="xl" href="https://www.researchgate.net/profile/Nikhil-Pawar-10" target="_blank" /></EuiFlexItem>
                        <EuiFlexItem grow={false}><EuiButtonIcon iconType={googlescholar} iconSize="xl" href="https://scholar.google.com/citations?user=qEn_zLAAAAAJ&hl=en" target="_blank" /></EuiFlexItem>
                        <EuiFlexItem grow={false}><EuiButtonIcon iconType={github} iconSize="l" href="https://github.com/nikhil0433" target="_blank" /></EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiCard>
                </EuiFlexItem></EuiFlexGroup>
                <EuiFlexGroup><EuiFlexItem>
                    <EuiCard
                    icon={<EuiIcon type={gmail} size="xl" />}
                    layout='horizontal'
                    textAlign="left"
                    title={<EuiText><b>Emails</b> </EuiText>}
                    titleSize="xs">
                        <EuiLink color='text' href='mailto:info@nikhilpawar.nik433@gmail.com'>nikhilpawar.nik433@gmail.com</EuiLink>
                    </EuiCard>
                </EuiFlexItem>
                <EuiFlexItem>
                    <EuiCard
                    icon={<EuiIcon type={phone} size="xl" />}
                    layout='horizontal'
                    textAlign="left"
                    title={<EuiText><b>Cell</b> </EuiText>}
                    titleSize="xs">
                        <EuiText>+91 9921985369</EuiText>
                    </EuiCard>
                </EuiFlexItem></EuiFlexGroup>
                <EuiSpacer size='xxl'/>
                <EuiSpacer size='xxl'/>
                <EuiSpacer size='xxl'/>
                <EuiSpacer size='xxl'/>
{/* //                 <EuiFlexGroup>
//                 <EuiFlexItem><EuiText textAlign="center" size='s'>
//                     <p>© Nikhil Pawar | Developed by <EuiLink href="https://www.linkedin.com/in/saurav-chavan-87ba09193/" color='text'><u>Saurav Chavan</u></EuiLink> & <EuiLink href="https://www.linkedin.com/in/ravi-shinde-0b3109174/" color='text'><u>Ravi Shinde</u></EuiLink></p>
//                 </EuiText></EuiFlexItem>
//                 </EuiFlexGroup> */}
                <EuiSpacer size='xxl'/>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Contact }
